import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionsGameSelectorComponent } from './questions-game-selector/questions-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { QuestionsGameCoreService } from './questions-game-core.service';

@NgModule({
  declarations: [QuestionsGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [QuestionsGameCoreService],
  exports: [QuestionsGameSelectorComponent],
})
export class QuestionsGameCoreModule {}
